import React from 'react';

export default function ValidationErrorMessage({errorMessage, fieldName}) {
  let isError = errorMessage && errorMessage.length > 0;
  let temporaryStyles = {
    float: "right",
    position: "absolute",
    right: 0
  };
  if (isError) {
    return (
      <p className="form-input__error" style={temporaryStyles}>
        {errorMessage}
      </p>
    );
  } else {
    return null;
  }
}
